import * as $ from 'jquery';

import { BookPrice, priceList } from "./bookprice";
import { formatCurrency } from "./utility";

const SALESTAXRATE = 0.09;
const SHIPPERBOOK = 1.0;
const MINSHIPPING = 5.0;


export class Cart {
    showPurchase: boolean;
    $ddQuantity: JQuery;
    $priceTable: JQuery;
    $cart: JQuery;
    quantity: number;
    bookeach: number;
    booktotal: number;
    shipping: number;
    salestax: number;
    grandtotal: number;
    discounttext: string;

    constructor() {
        this.showPurchase = false;
        this.$ddQuantity = $('#ddquantity');
        this.$priceTable = $('#pricetable');
        this.$cart = $("#cart");
    }

    setup() {
        this.fillQuantity();
        this.showPriceTable();
    }

    fillQuantity() {
        const self = this;
        let html = "<option value=''>- Select Quantity -</option>";
        for (var quan = 1; quan <= 500; ++quan) {
            html += `<option value='${quan}'>${quan}</option>`;
        }
        this.$ddQuantity.html(html);

        this.$ddQuantity.on("change", () => self.update());
    }

    update() {
        const sQuan = <string>this.$ddQuantity.val();
        if (!sQuan) {
            this.$cart.hide();
            return;
        }
        this.quantity = parseInt(sQuan);
        const book = Cart.getSelectedPrice(this.quantity);

        this.bookeach = book.price;
        this.discounttext = book.discounttext;
        this.booktotal = this.bookeach * this.quantity;
        this.shipping = SHIPPERBOOK * this.quantity;
        if (this.shipping < MINSHIPPING) {
            this.shipping = MINSHIPPING;
        }

        this.grandtotal = this.booktotal + this.shipping;

        this.showCart();
    }

    showCart() {
        let html = '<table class="bookordertable">';
        html += '<tr><th class="quantity">Quantity</th><th class="unitprice">Unit Price </th><th class="price"> Total </th></tr>';
        html += `<tr><td class="quantity">${this.quantity}</td>`;
        html += `<td class="unitprice">${formatCurrency(this.bookeach)} (${this.discounttext})</td>`;
        html += `<td class="price">${formatCurrency(this.booktotal)}</td></tr>`;

        html += `<tr><td class='shipping' colspan='2'>Shipping</td><td class='price'>${formatCurrency(this.shipping)}</td></tr>`;
        html += `<tr><td class='total' colspan='2'>Total</td><td class='price'>${formatCurrency(this.grandtotal)}</td></tr>`;

        html += "</table>";

        html += `<input type="hidden" name="quantity" value="${this.quantity}"/>`;
        html += `<p class='text-center mt-3'><input class="btn btn-danger" type='submit' value='Purchase now'/></a>.</p>`
        this.$cart.html(html).show();
    }

    showPriceTable() {
        let html = "<table class='pricetable'>";
        html += "<thead><tr><th class='name'>Number of books</th><th class='price'>Price Each</th></tr></thead>";
        html += "<tbody>";
        for (var row of priceList) {
            html += "<tr><td class='name'>";
            html += "<span class='fw-semibold'>" + row.name + "</span>";
            html += " <span class='fw-normal'>(" + row.discounttext + ")</span></td>"
            html += "<td class='price'>" + formatCurrency(row.price) + "</td></tr>";
        }

        html += "</tbody>";

        html += "</table>";
        this.$priceTable.html(html);
    }

    static getSelectedPrice(quan: number): BookPrice {
        for (var i = 0; i < priceList.length; ++i) {
            const book = priceList[i];
            if (quan >= book.lowcount && quan <= book.highcount) {
                return book;
            }
        }
        return priceList[0];
    }
}